module.exports = __webpack_public_path__ + "img/191.toiletries.a21e2be5.svg";